export const COURSE_TYPES = {
  academy: 'academy',
  dsml: 'data_science',
  neovarsity: 'neovarsity',
  academyWithoutDsa: 'academy_without_dsa',
} as const;
